import { useEffect } from "react";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { Context } from "../../../config/store";
import message from "../../../constant/message";
import LenderUgroService from "../../../services/lender";
import Modal from "../../Modal";
import Spinner from "../../Spinner";
import BREhelper from "../../Common/BREhelper";
import ReactTooltip from "react-tooltip";

const styleHeading = {
  backgroundColor: "#ea652b",
  fontSize: "11px",
  color: "white",
  padding: "0.35rem",
  fontWeight: "bold",
  width: "100%",
  // height: "25px",
};

const EligibleLenderUserModal = ({
  loading,
  modelState,
  toggleModal,
  allLenderList,
  selectedIds,
  reloadTable,
  getAllLenderList
}) => {
  const { state } = useContext(Context);
  const [lendingDetails, setLendingDetails] = useState([]);
  const [errors, setErrors] = useState({});
  // const [currentUser, setCurrentUser] = useState(null);
  const [showDetails, setshowDetails] = useState(false);
  const [finalResult, setfinalResult] = useState(false);
  const [selectedLender, setSelectedLender] = useState('');


  // const showDetailModel = () => {
  //   setshowDetails(!showDetails);
  // };

  const checkLendingDetails = async (lender_id, selected_lender) => {

    try {
      let response;
      response = await LenderUgroService.checkLendingDetails({
        type: state.userType,
        requestBody: {
          // lender_id: selectedIds[0],
          lender_id: lender_id,
          lead_id: selectedIds,
        },
      });
      if (response?.data?.status?.code === 1) {
        const successMessage = response?.data?.messages?.success;
        setSelectedLender(selected_lender);
        setfinalResult(response.data?.data?.data?.final_result);
        // Object.entries(response.data.data.data?.rules_result).map(
        //   ([key, value]) => {
        //     setLendingDetails((prev) => {
        //       return { ...prev, ...value?.varResult };
        //     });
        //   }
        // );
        setLendingDetails(response.data.data.data?.rules_result)
        setshowDetails(!showDetails);
        if (
          Object.entries(response.data.data.data?.rules_result).length !== 0
        ) {
          toast.success(
            successMessage?.form?.[0] ||
            successMessage?.others?.[0]
          );
        }

      } else {
        toast.error(message.Not_AVAILABLE);
      }
      // if (reloadTable) reloadTable();
      // toggleModal();
    } catch (err) {
      let error = err?.response?.data?.messages?.error;
      toast.error(error?.form?.[0] || error?.others?.[0]?.replace(".message", "") || message.ERROR_FORM);
      setErrors(error);
    }
  };

  Object.entries(lendingDetails).map(([key, value]) => {
    // console.log(key, value);
  });
  // const setSelectedUser = (e) => {
  //   setCurrentUser(e.target.value);
  // };
  useEffect(() => {
    reloadTable();
  }, []);
  const checkHasPermission = (checkPermission) => {
    if (state.is_super_admin === 1) return true;
    const permission = state.permission.find(
      (permission) => permission === checkPermission
    );

    if (permission) return true;
    else return false;
  };
  return (
    <>
      <Modal
        style={{
          // minWidth: "45%",
          padding: "0px",
          backgroundColor: "transparent",
          width: '600px',
        }}
        state={modelState}
        closeModal={toggleModal}
        removeBorderSpace={true}
      >
        {loading && (
          <>
            {/* <div className="float-right">
              <button
                type="button"
                data-dismiss="modal"
                onClick={toggleModal}
                className="btn btn-custom p-2"
              >
                <span className="fs-6">X</span>
              </button>
            </div> */}
            <div className="modal-header-container">
              <div className="modal-title">Calculating Lender Eligibility</div>
              <div className="closeModalView" onClick={toggleModal}>
                <span className="closeModalIcon">x</span>
              </div>
            </div>
            <div className="p-4 modalData">
              <div className="d-flex h-100 align-items-center justify-content-center flex-1">
                <Spinner />
              </div>
              <p className="text-center bold lead">Please wait, calculating lender eligibility.</p>
            </div>
          </>
        )}

        {!loading && (
          <div>
            {!showDetails && <div style={{ filter: showDetails ? "blur(2px)" : "none" }}>
              <div className="modal-header-container">
                <div className="modal-title">Lender Eligibility</div>
                <div className="closeModalView" onClick={toggleModal}>
                  <span className="closeModalIcon">x</span>
                </div>
              </div>
              {checkHasPermission('refresh-bre-eligibility') && <div className="d-flex justify-content-end">
                <button className="btn btn-custom mt-2 mr-2"
                  onClick={() => getAllLenderList(1)}
                > Refresh </button>
              </div>}
              <div className="p-4">
                <div className='row'>
                  <div className="col-md-6 text-center">
                    <h6 className='font-weight-bolder pb-2' style={{ borderBottom: '1px dashed #a3a2a2' }}>Eligible Lenders</h6>
                  </div>
                  <div className="col-md-6 text-center" >
                    <h6 className='font-weight-bolder pb-2' style={{ borderBottom: '1px dashed #a3a2a2' }}>Non Eligible Lenders</h6>
                  </div>
                </div>
                {/* <div className="container"> */}
                <div className="row text-center">
                  <div className="col-md-6">
                    {(allLenderList?.eligible || []).map(
                      ({ cl_lender_id, lender }) => (
                        <div
                          className="cursor-pointer mr-4"
                          value={cl_lender_id}
                          key={cl_lender_id}
                          onClick={() => {
                            checkLendingDetails(cl_lender_id, lender.lender_name);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {lender.lender_name}
                        </div>
                      )
                    )}
                    <div
                      className="cursor-pointer mr-4"
                      style={{ cursor: "pointer", paddingLeft: "5px", color: "grey" }}
                    >
                      {"ugro Capital"}
                    </div>
                  </div>
                  <div className="col-md-6 text-center">
                    {/* <div style={{ ...styleHeading }}>Non Eligible Lenders</div> */}
                    {(allLenderList?.not_eligible || []).map(
                      ({ cl_lender_id, lender }) => (
                        <div
                          className="cursor-pointer"
                          value={cl_lender_id}
                          key={cl_lender_id}
                          onClick={() => {
                            checkLendingDetails(cl_lender_id, lender.lender_name);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          {lender.lender_name}
                        </div>
                      )
                    )}
                  </div>
                </div>
                {/* </div> */}
                {errors && (
                  <p className="mt-2 mb-0 text-danger">
                    {errors?.fields?.lender_id?.[0]}
                  </p>
                )}
              </div>
            </div>}

            {/* other modal */}
            {showDetails && Object.entries(lendingDetails).length !== 0 ? (
              <div
                style={{
                  backgroundColor: "white",
                  boxShadow: 24,
                  // marginTop: "-42%",
                  zIndex: 9,
                  padding: "-10px",
                  backdropFilter: "blur(5px)",
                  width: "100%",
                  height: "100%",
                  borderRadius: "15px",
                  marginBottom: "20px"
                }}
              >
                <div className="float-right">
                  {/* <button
                    type="button"
                    data-dismiss="modal"
                    onClick={() => {
                      setshowDetails(!showDetails);
                    }}
                    style={{
                      fontSize: "10px",
                      fontWeight: 500,
                      marginBottom: "10px",
                      cursor: "pointer",
                      color: "white",
                      paddin: "3px",
                      border: "transparent",
                      backgroundColor: "#ea652b",
                      marginBottom: '10px',
                      marginRight: '10px',
                      marginTop: '7px',
                      boxShadow: '1px 1px 6px 1px rgb(0 0 0 / 20%)',
                      padding: '1px 5px',
                      borderRadius: '50%'
                    }}
                  >
                    <span className="fs-6">X</span>
                  </button> */}
                </div>
                <div className="modal-header-container">
                  <div className="modal-title">{'Policy Parameter'}</div>
                  <div className="closeModalView"   onClick={() => {
                      setshowDetails(!showDetails);
                    }}>
                    <span className="closeModalIcon">x</span>
                  </div>
                </div>
                <div style={{ fontSize: "16px", fontWeight: 500, textAlign: "center",marginTop:'10px' }}>
                  {selectedLender}
                </div>
                <div style={{ fontSize: "16px", fontWeight: 500, textAlign: "center" }}>
                  Overall Result : {finalResult ? <span style={{ color: "green" }}>True</span> : <span style={{ color: "red" }}>False</span>}
                </div>
                <br />
                <div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "34% 34% 34%",
                      padding: " 0 1rem",
                      gap: "30px",
                      alignItems: "center",
                    }}
                  >

                    <div style={{ fontSize: "15px", fontWeight: 500 }}>
                      Parameter
                    </div>
                    <div style={{ fontSize: "15px", fontWeight: 500 }}>
                      {" "}
                      Parameter Value
                    </div>
                    <div style={{ fontSize: "15px", fontWeight: 500 }}>
                      {" "}
                      Status
                    </div>
                  </div>
                  <div style={{ maxHeight: "50vh", overflowY: "auto", overflowX: "clip", paddingBottom: "15px" }}>
                    {lendingDetails?.application?.varResult && <div className="col mb-1">
                      <div className="row">
                        <div className="col-4">
                          <hr />
                        </div>
                        <div className="col-4 text-center">
                          <span className="font-weight-bold">Applicant</span>
                        </div>
                        <div className="col-4">
                          <hr />
                        </div>
                      </div>
                      {Object.entries(lendingDetails?.application?.varResult)?.map(([key, value]) => {
                        return (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "34% 34% 34%",
                              marginTop: "4px",
                              gap: "30px",
                              alignItems: "center",
                              fontSize: "12.5px",
                              fontWeight: "400",
                            }}
                          >
                            <div style={{wordWrap:"break-word"}}>{key}</div>
                            <div style={{ marginLeft: "5%" }}>
                              {/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
                              <BREhelper value={value} />
                            </div>
                            {/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
                            <span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}1`} data-tip></i></span> </span>
                            <ReactTooltip id={`${key}1`} >{value?.message}</ReactTooltip>
                          </div>
                        );
                      })}
                    </div>}
                    {lendingDetails?.commercial_bureau?.varResult && <div className="col mb-1">
                      {Object.entries(lendingDetails?.commercial_bureau?.varResult)?.map(([key, value]) => {
                        return (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "34% 34% 34%",
                              marginTop: "4px",
                              gap: "30px",
                              alignItems: "center",
                              fontSize: "12.5px",
                              fontWeight: "400",
                            }}
                          >
                            <div style={{wordWrap:"break-word"}}>{key}</div>
                            <div style={{ marginLeft: "5%" }}>
                              {/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
                              <BREhelper value={value} />
                            </div>
                            {/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
                            <span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}2`} data-tip></i></span> </span>
                            <ReactTooltip id={`${key}2`} >{value?.message}</ReactTooltip>
                          </div>
                        );
                      })}
                    </div>}
                    {lendingDetails?.consumer_bureau?.varResult && <div className="col mb-1">
                      <div className="row">
                        <div className="col-4">
                          <hr />
                        </div>
                        <div className="col-4  text-center">
                          <span className="font-weight-bold">Co-Applicant</span>
                        </div>
                        <div className="col-4">
                          <hr />
                        </div>
                      </div>
                      {Object.entries(lendingDetails?.consumer_bureau?.varResult)?.map(([key, value]) => {
                        return (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "34% 34% 34%",
                              marginTop: "4px",
                              gap: "30px",
                              alignItems: "center",
                              fontSize: "12.5px",
                              fontWeight: "400",
                            }}
                          >
                            <div style={{wordWrap:"break-word"}}>{key}</div>
                            <div style={{ marginLeft: "5%" }}>
                              {/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
                              <BREhelper value={value} />
                            </div>
                            {/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
                            <span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}3`} data-tip></i></span> </span>
                            <ReactTooltip id={`${key}3`} >{value?.message}</ReactTooltip>
                          </div>
                        );
                      })}
                    </div>}
                    {lendingDetails?.banking?.varResult && <div className="col mb-1">
                      <div className="row">
                        <div className="col-4">
                          <hr />
                        </div>
                        <div className="col-4  text-center">
                          <span className="font-weight-bold">Banking</span>
                        </div>
                        <div className="col-4">
                          <hr />
                        </div>
                      </div>
                      {Object.entries(lendingDetails?.banking?.varResult)?.map(([key, value]) => {
                        return (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "34% 34% 34%",
                              marginTop: "4px",
                              gap: "30px",
                              alignItems: "center",
                              fontSize: "12.5px",
                              fontWeight: "400",
                            }}
                          >
                            <div style={{wordWrap:"break-word"}}>{key}</div>
                            <div style={{ marginLeft: "5%" }}>
                              {/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
                              <BREhelper value={value} />
                            </div>
                            {/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
                            <span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}3`} data-tip></i></span> </span>
                            <ReactTooltip id={`${key}3`} >{value?.message}</ReactTooltip>
                          </div>
                        );
                      })}
                    </div>}
                    {lendingDetails?.karza_gstin?.varResult && <div className="col mb-1">
                      <div className="row">
                        <div className="col-4">
                          <hr />
                        </div>
                        <div className="col-4  text-center">
                          <span className="font-weight-bold">GSTIN</span>
                        </div>
                        <div className="col-4">
                          <hr />
                        </div>
                      </div>
                      {Object.entries(lendingDetails?.karza_gstin?.varResult)?.map(([key, value]) => {
                        return (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "34% 34% 34%",
                              marginTop: "4px",
                              gap: "30px",
                              alignItems: "center",
                              fontSize: "12.5px",
                              fontWeight: "400",
                            }}
                          >
                            <div style={{wordWrap:"break-word"}}>{key}</div>
                            <div style={{ marginLeft: "5%" }}>
                              {/* {value.value == 0 ? value.value : (value.value == null || value.value == "" ? "----" : (typeof value.value === 'number' ? value.value.toFixed(2).replace('.00', '') : value.value))} */}
                              <BREhelper value={value} />
                            </div>
                            {/* <div style={{ marginLeft: "5%" }}>{value.result ? "true" : "false"}</div> */}
                            <span style={{ marginLeft: "5%", }} className={value.result ? "" : "text-danger"} >{value.result ? `true ` : "false"}<span className="ml-1"><i class="fa fa-info-circle" data-for={`${key}3`} data-tip></i></span> </span>
                            <ReactTooltip id={`${key}3`} >{value?.message}</ReactTooltip>
                          </div>
                        );
                      })}
                    </div>}
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        )}
      </Modal>
    </>
  );
};

export default EligibleLenderUserModal;
